import { all, takeEvery, put, call, fork } from 'redux-saga/effects';
import { notification } from '@iso/components';
import CountryApi from '@iso/lib/api/countryHelper';
import actions from './actions';



export function* countryCreateRequest() {
  yield takeEvery(actions.COUNTRY_ADD_NEW, function* ({ payload }) {
    console.log("payloaddddd",payload);
    const result = yield call(CountryApi.create, payload.dataObj);
    console.log("resulttttttpayload",result);
    if (result.status === 0) {
      notification('error', result.message);
    } else {
      console.log("payload.dataObj","200");
      notification('success', result.message);
      yield put({
        type: actions.COUNTRY_READ,
        success: true,
        msg: result.message,
      });
      window.location.reload(true)
      // payload.history.push('/dashboard/listCountry');
    }
  });
}

export function* countryReadRequest() {

  yield takeEvery(actions.COUNTRY_READ, function* ({ payload }) {
    console.log("payloadddddRead",payload);
    try {
      const searchResult = yield call(CountryApi.read, payload.readFilter, payload.page);
      console.log("payloadddddsearchResult",searchResult);
      if (searchResult.status) {
        yield put(
          actions.countryReadSearchSuccess(
            searchResult.result,
            true,
            searchResult.totalRecordCount,
            payload.page
          )
        );
      } else {
        notification('error', searchResult.message);
        yield put(
          actions.countryReadSearchSuccess({},false,0,0)
        );
      }
    } catch (error) {
      console.log("Error::::::::::::::", error);
      //  yield put(actions.gitSearchSuccess());
    }
  })
}


/*****fetch record by id *************/
export function* countryFindByIdRequest() {
  yield takeEvery(actions.COUNTRY_FIND_BY_ID, function* ({ payload }) {
    try {
      const result = yield call(CountryApi.findById, payload.countryId);
      if (result.success) {
        notification('success', result.message);
        yield put({
          type: actions.COUNTRY_ITEM_SUCCESS,
          result: result.data,
          success: result.success
        });
      } else {
        notification('error', result.message);
      }
    } catch (error) {
    }
  });
}


export default function* rootSaga() {
  yield all([
    fork(countryCreateRequest),
    fork(countryReadRequest),
  ]);
}
